import { useEffect, useState } from 'react'
import Modal from './Modal'
import { initSpinDuration } from '../../../UI/Cube/Cube'
import Video from './Video'
import { Gender } from '../../../hooks/useCubeItems/kandi/wahlkreisData'

type Props = {
  gender?: Gender
  isTopic?: boolean
}

const VideoPopup: React.FC<Props> = ({ gender, isTopic }) => {
  const [isVisible, setIsVisible] = useState(false)

  const toggle = () => setIsVisible(!isVisible)

  useEffect(() => {
    const popupParam = new URL(window.location.href).searchParams.get('popup')
    const showPopup = !popupParam
    if (showPopup) {
      setTimeout(() => {
        setIsVisible(true)
        // const url = new URL(window.location.href)
        // url.searchParams.set('popup', 'false')
        // window.history.pushState({}, '', url)
      }, initSpinDuration * 1100)
    }
  }, [])

  const isKandi = !!gender

  return (
    <Modal large={!isKandi} noForm show={isVisible} closeIcon onClose={toggle}>
      <Video skip={toggle} gender={gender} isTopic={isTopic} />
    </Modal>
  )
}

export default VideoPopup
